// extracted by mini-css-extract-plugin
module.exports = {"firstToknowModal":"firstToKnow-module--firstToknowModal--sjtKc","content":"firstToKnow-module--content--2fqgZ"};